import { useForm } from "react-hook-form";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useState } from "react";
import { toast } from "react-toastify";
import { apiPost } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { pick } from "lodash";

export default function AddWebsite({ isOpen, closeModal,getData }) {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const [isLoader, setLoader] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (request) => {
    setLoader(true);
    try {
      const { status, data } = await apiPost(
        apiPath.createWebsite,
        pick(request, ["domain", "name"]),
      );
      if (status === 200 && data.success) {
        toast.success(data.message);
        getData()
        closeModal();
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };
  return (
    <div
      id="addUserModal"
      className="pop_bg"
      style={{ height: "100%", width: "100%", display: "block" }}
      onClick={closeModal}
    >
      <div className="pop_box pop_refer" onClick={(e) => e.stopPropagation()}>
        <a
          href="#"
          className="close_pop"
          onClick={(e) => {
            e.preventDefault();
            closeModal();
          }}
        >
          close_pop
        </a>

        <h3 className="modal-header">Add Website</h3>

        <form
          noValidate
          style={{ display: "flex", flexFlow: "column" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div id="modalid" className="modal-content">
            <ul className="half_box add-member-box">
              <li className="add_account_box">
                <dl>
                  <div style={{ position: "relative", marginBottom: "15px" }}>
                    <dt>Name</dt>
                    <dd style={{ position: "relative" }}>
                      <input
                        id="name"
                        type="text"
                        maxLength={30}
                        placeholder="Enter"
                        appinputrestriction="noSpecialChars"
                        {...register("name", {
                          required: "Please enter name",
                        })}
                      />
                      <span className="must rg-mark">＊</span>
                      {errors.name && (
                        <span id="nameErrorText" className="error-text">
                          {errors.name.message}
                        </span>
                      )}
                    </dd>
                  </div>

                  <div style={{ position: "relative", marginBottom: "15px" }}>
                    <dt>Website Name</dt>
                    <dd style={{ position: "relative" }}>
                      <input
                        id="domain"
                        type="text"
                        placeholder="Enter"
                        {...register("domain", {
                          required: "Enter website name",
                        })}
                      />
                      <span className="must rg-mark">＊</span>
                      {errors.domain && (
                        <span id="domainErrorText" className="error-text">
                          {errors.domain.message}
                        </span>
                      )}
                    </dd>
                  </div>
                </dl>
              </li>
            </ul>
          </div>

          <div className="modal-footer">
            <div style={{ width: "100%" }} className="btn_box">
              <button
                style={{ marginTop: "0" }}
                type="submit"
                className="btn-send size-btn"
                disabled={isSubmitting || isLoader}
              >
                {isLoader ? "Please wait..." : "Add"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
